export const MAX_BOOKING_TITLE_LENGTH = 80;

export function resolveBookingTitle(
  bookingTitle: string | null | undefined,
  establishmentName: string | null | undefined,
): string {
  const customTitle = bookingTitle?.trim();
  if (customTitle) return customTitle;

  const name = establishmentName?.trim();
  return name ? `Réserver chez ${name}` : 'Réserver une table';
}